import { LeftOutlined } from '@ant-design/icons';
import { Typography } from 'antd';
import { ReactNode } from 'react';

const { Title } = Typography;

const PageTitle = ({
    onClick,
    title,
    children,
}: {
    onClick: () => void;
    title: string;
    children?: ReactNode;
}) => {
    return (
        <div className="d-flex align-items-center justify-content-between mt-2 mb-4">
            <div className="flex align-items-center">
                <LeftOutlined
                    className="left-arrow"
                    onClick={onClick}
                    rev={undefined}
                />
                <Title level={1} className="m-0 text-nowrap">
                    {title}
                </Title>
            </div>
            {children}
        </div>
    );
};

export default PageTitle;
